import * as Styles from "./StatusInfoCard.styles";

interface StatusInfoCardProps {
  image: string;
  title: string;
  total?: number;
}

export default function StatusInfoCard({ image, title, total }: StatusInfoCardProps) {
  return (
    <Styles.StyledCardPaper elevation={1}>
      <Styles.Container>
        <Styles.ImageContainer>
          <img src={image} alt={title} />
        </Styles.ImageContainer>

        <Styles.TextInfoContainer>
          <span>{title}</span>
          {(total ?? 0) > 0 && (
            <span>
              : <Styles.TotalValue>{total}</Styles.TotalValue>
            </span>
          )}
        </Styles.TextInfoContainer>
      </Styles.Container>
    </Styles.StyledCardPaper>
  );
}
